<template>

    <div id="report-results" v-if="value">

        <div class="w-full px-8 py-4 mb-4 bg-gray-700 text-white text-sm flex mt-4">
            <svg xmlns="http://www.w3.org/2000/svg" class="w-20 md:w-12 lg:w-6 text-brand-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" focusable="false" role="img" aria-label="report-results-warning">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
            <p class="ml-4">
                This is a preview of the report results, and the preview only displays the first <span class="font-semibold">{{ previewLimit }}</span> results. To view the entire result set please
                <a href="#" class="bg-dark" @click.prevent="triggerReportExport">export the results</a>.
            </p>
        </div>

        <div class="flex full mb-4 items-center">
            <div class="flex-1 font-medium text-base">&nbsp;</div>

            <button class="btn-error ml-3 text-sm" @click.prevent="toggleQuery" v-show="is_admin">
                Show Query
            </button>

            <router-link :to="{ name: 'report.edit', params: { report: value.report_structure.id } }" class="btn-error text-sm ml-3 hover:text-white" v-show="is_admin">
                Edit Report
            </router-link>

            <button class="btn-outline text-sm ml-3" @click.prevent="value.resetReportPreview()">
                Edit Parameters
            </button>

            <button class="btn text-sm ml-3" @click.prevent="triggerReportExport">
                Export Report
            </button>
        </div>

        <div class="flex mb-6">
            <div class="w-1/2 text-sm mr-3 bg-white shadow rounded-lg p-6">
                <h2 class="flex-1 font-medium text-base">{{ value.report_structure.name }}</h2>

                <p class="text-gray-500 pt-2">
                    {{ value.report_structure.description }}
                </p>
            </div>
            <div class="w-1/2 pl-3">
                <table class="responsive-table text-sm shadow">
                    <thead>
                    <tr>
                        <th class="uppercase text-xs text-left" colspan="2">Parameters</th>
                    </tr>
                    </thead>
                    <tbody>
                        <tr class="colored-row" v-for="parameter in value.report_results.parameters">
                            <td class="font-medium">{{ parameter.name }}</td>
                            <td>{{ parameter.value }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="bg-white overflow-hidden shadow rounded-lg p-6 mb-6 text-sm" v-if="is_admin && show_query">
            <p class="text-error-500">
                {{ value.report_results.raw }}
            </p>
        </div>

        <table class="responsive-table text-sm shadow">
            <thead>
            <tr>
                <th class="uppercase text-xs text-left" v-for="heading in value.report_results.headings">
                    {{ heading }}
                </th>
            </tr>
            </thead>
            <tbody>
                <tr class="colored-row" v-for="result in value.report_results.data">
                    <td v-for="column in result">
                        {{ column }}
                    </td>
                </tr>
            </tbody>
        </table>

    </div>

</template>

<script>
import {PermissionMixin} from "../../support/mixins";

export default {
    name: "ReportResults",
    mixins: [PermissionMixin],
    props: {
        value: {
            type: Object
        },
        is_admin: {
            type: Boolean,
            required: false,
            default: false
        },
    },
    data() {
        return {
            show_query: false,
            export_started: false
        }
    },
    computed: {
        previewLimit() {
            let result = this.value.report_results;

            if (result) {
                return result.result_limit;
            }

            return '-';
        }
    },
    methods: {
        toggleQuery() {
            this.show_query = ! this.show_query;
        },
        triggerReportExport() {
            let vm = this;
            vm.export_started = true;

            vm.value.renderQueuedReport(vm.value.report_structure.id).then(r => {
                vm.showPendingReports();
            }).catch(error => vm.handleError(error));
        },
        showPendingReports() {
            this.$emit('showPendingReports');
        }
    },
}
</script>
